import React from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import { CirclePicker } from 'react-color'
import Popup from '@components/popups/basic-modal'
import styles from '../index.module.scss'
import Tooltip from '@components/tooltip'
import MediaLibraryPopup from '@containers/media-library/media/media-library'
import TimeInput from '@components/timeInput'
import Icons from '@components/icons'
import notification from '@components/notification'
import { slotConversionFunction, isEnabled, isDisabled, generateImageUrl } from '@helpers/utility'
import moment from 'moment'
import OnClickOutside from '@components/outsideClickComponent'
import BusinessHoursModal from './businessHoursModal'
import { segmentEventTrack } from '@helpers/segment'
import config from '@config/index'
import i18next from 'i18next'

const arrayOrder = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']

const defaultHours = {
  monday: {
    slots: [
      {
        time_start: '00:00 AM',
        time_end: '00:00 AM'
      }
    ],
    open: true,
    open_allday: true
  },
  tuesday: {
    slots: [
      {
        time_start: '00:00 AM',
        time_end: '00:00 AM'
      }
    ],
    open: true,
    open_allday: true
  },
  wednesday: {
    slots: [
      {
        time_start: '00:00 AM',
        time_end: '00:00 AM'
      }
    ],
    open: true,
    open_allday: true
  },
  thursday: {
    slots: [
      {
        time_start: '00:00 AM',
        time_end: '00:00 AM'
      }
    ],
    open: true,
    open_allday: true
  },
  friday: {
    slots: [
      {
        time_start: '00:00 AM',
        time_end: '00:00 AM'
      }
    ],
    open: true,
    open_allday: true
  },
  saturday: {
    slots: [
      {
        time_start: '00:00 AM',
        time_end: '00:00 AM'
      }
    ],
    open: true,
    open_allday: true
  },
  sunday: {
    slots: [
      {
        time_start: '00:00 AM',
        time_end: '00:00 AM'
      }
    ],
    open: true,
    open_allday: true
  }
}
const serviceLocations = [
  { label: 'My Business Location', value: 'business_address', id: 'business_address' },
  { label: "Customer's Address", value: 'customer_address', id: 'customer_address' }
]

const prepTimes = [
  { value: 0, label: 'None' },
  { value: 5, label: '5 minutes' },
  { value: 10, label: '10 minutes' },
  { value: 15, label: '15 minutes' },
  { value: 20, label: '20 minutes' },
  { value: 25, label: '25 minutes' },
  { value: 30, label: '30 minutes' },
  { value: 45, label: '45 minutes' },
  { value: 60, label: '60 minutes' }
]
const dateRanges = [
  { value: 15, label: '15 days' },
  { value: 30, label: '30 days' },
  { value: 60, label: '60 days' },
  { value: 90, label: '90 days' },
  { value: 100, label: '100 days' }
]
const startTimeIncrements = [
  { value: 15, label: '15 minutes' },
  { value: 30, label: '30 minutes' },
  { value: 60, label: '60 minutes' }
]
const amountDueTypes = [
  // { value: 'none', label: 'None' },
  { value: 'full', label: 'Full Payment' },
  { value: 'partial', label: 'Deposit/Partial Payment' }
]
const amountTypes = [
  { value: 'amount', label: '$' },
  { value: 'percentage', label: '%' }
]

class AddServicePopUp extends React.Component {
  t = i18next.t
  constructor(props) {
    super(props)
    this.state = {
      popUPOpen: false,
      imageModalOpen: false,
      service_image: '',
      reminder_image: '',
      businessHours: {},
      selectedItem: {
        minimum_payment_amount: 0,
        minimum_payment_percentage: 0
      },
      serviceUser: '',
      type: '',
      submitting: false,
      slotError: '',
      reenitialiseStatus: true,
      showColorPicker: false,
      bookingStatus: false,
      enlargeImage: false,
      textAreaInitialHeight: '44px'
    }
    this.sortArrayFunction = this.sortArrayFunction.bind(this)
  }
  sortArrayFunction(bussHrs) {
    const newObj = {}
    arrayOrder.forEach((item) => (newObj[item] = bussHrs[item]))
    return JSON.parse(JSON.stringify(newObj))
  }
  async showPopup(item, type) {
    this.setState({ popUPOpen: true, type: type })
    if (this.props && this.props.products && isEnabled('booking', this.props.products)) {
      this.setState({ bookingStatus: true })
    } else {
      this.setState({ bookingStatus: false })
    }
    if (item) {
      await this.setState({ dataFetching: true })
      this.setState({ old_user_id: item.user_id })
      await this.props.getServiceUserFunction(item._id)
      this.setState({
        serviceUser: this.props.serviceUSer && this.props.serviceUSer.user_id,
        service_image: item.service_image ? item.service_image : '',
        reminder_image: item.reminder_image ? item.reminder_image : '',
        dataFetching: false
      })
      const editService = { ...this.props.editService }
      if (editService) {
        if (editService && !editService.minimum_payment_amount) {
          editService.minimum_payment_amount = 0
        }
        if (editService && !editService.minimum_payment_percentage) {
          editService.minimum_payment_percentage = 0
        }
      }
      await this.setState({
        selectedItem: editService,
        businessHours: slotConversionFunction(this.sortArrayFunction(this.props.editService.business_hours))
      })
    }
  }
  async closeModal(reset, resetForm) {
    await this.setState({ popUPOpen: false, submitting: false })
    await this.props.changeshowAddService()
    if (reset) this.reset(resetForm)
  }
  async stopSpinner() {
    await this.setState({ submitting: false })
  }
  reset(resetForm) {
    resetForm({
      title: '',
      duration: '',
      descripton: '',
      block_off: false,
      block_off_time: '',
      appointment_reminder_flag: true,
      appointment_reminder_time_new: [{ hour: '00', min: '00' }],
      appointment_calendar_color: '',
      notify_owner: true,
      notify_owner_email: true,
      notify_owner_sms: false,
      price: '',
      minimum_payment_type: '',
      minimum_payment_amount: '',
      minimum_payment_percentage: '',
      free_consultation: false,
      is_business_hours: true,
      business_hours: defaultHours,
      user_id: '',
      payment: true
    })
    this.setState({
      service_image: '',
      reminder_image: '',
      selectedItem: {},
      slotError: '',
      serviceUser: '',
      reenitialiseStatus: true
    })
  }
  bussinessHoursFormattingFN(busshr) {
    for (const key in busshr) {
      busshr[key].slots &&
        // eslint-disable-next-line
        busshr[key].slots.forEach((slotItem, index) => {
          if (slotItem.time_start1) {
            slotItem.time_start = slotItem.time_start1 + ' ' + slotItem.time_start2
          } else {
            slotItem.time_start = 'AM'
          }
          if (slotItem.time_end1) {
            slotItem.time_end = slotItem.time_end1 + ' ' + slotItem.time_end2
          } else {
            slotItem.time_end = 'PM'
          }
          if (moment(slotItem.time_start, 'HH:mm A').isAfter(moment(slotItem.time_end, 'HH:mm A'), 'minutes')) {
            this.setState({ slotError: this.t('settings.invalide-time-slot') })
          }
          if (
            !busshr[key].open_allday &&
            busshr[key].open &&
            (slotItem.time_start === 'AM' ||
              slotItem.time_end === 'PM' ||
              slotItem.time_start1 === '00:00' ||
              slotItem.time_end1 === '00:00')
          ) {
            this.setState({ slotError: this.t('settings.invalide-time-slot') })
          }
        })
    }
    return busshr
  }
  handleCancel(values, { resetForm }) {
    if (this.props.showGlobalModel) this.props.showGlobalModel()
    this.closeModal(true, resetForm)
  }
  async handleSubmit(values, { resetForm }) {
    await this.setState({ submitting: true, slotError: '' })
    let errorArr = []
    if (values.appointment_reminder_flag) {
      errorArr = values.appointment_reminder_time_new.map((item) => {
        return !(item.hour === '00' && item.min === '00')

        // reminderRegex.test(item.hour)
      })
    } else {
      values.appointment_reminder_time_new = []
    }
    if (errorArr.includes(false)) {
      notification('error', this.t('bookings.invalid-time-slots-found-in-reminder-time'))
      await this.setState({ submitting: false })
    } else {
      let payload = { ...values }
      if (payload.price === '') {
        payload.price = '0'
      }
      let newArr = []
      if (payload.payment) {
        if (
          this.props &&
          this.props.disabledProducts &&
          !isDisabled('payment', this.props.disabledProducts) &&
          this.props.me &&
          this.props.me.account_settings &&
          this.props.me.account_settings.payment &&
          this.props.me.account_settings.payment.merchant_id
        ) {
          payload.payment = true
        } else {
          payload.payment = false
        }
      }
      payload.service_image = this.state.service_image ? this.state.service_image : ''
      payload.reminder_image = this.state.service_image ? this.state.reminder_image : ''
      if (this.state.bookingStatus) {
        if (values.appointment_reminder_time_new && values.appointment_reminder_time_new.length !== 0) {
          newArr = values.appointment_reminder_time_new.map((item) => {
            return { ...item, value: Number(item.hour) * 60 + Number(item.min) }
          })
        }
        payload.appointment_reminder_time_new = newArr
        // if (payload.minimum_payment_amount || payload.minimum_payment_percentage) {
        //     payload.allow_partial_payment = true
        // }
        // else {
        //     payload.allow_partial_payment = false
        // }
        payload.block_off_time = payload.block_off_time ? payload.block_off_time : '0'
        payload.block_off = true
        payload.notify_owner = payload.notify_owner_email || payload.notify_owner_sms
      }
      if (
        payload.payment &&
        payload.allow_partial_payment &&
        payload.minimum_payment_type === 'amount' &&
        payload.minimum_payment_amount === ''
      ) {
        payload.minimum_payment_amount = 0
        payload.minimum_payment_percentage = 0
      }
      if (this.state.type === 'add') {
        if (!this.state.slotError) {
          await this.props.createService(payload, resetForm)

          const segmentData = {
            event: 'add_service',
            properties: {
              user_id: this.props.me && this.props.me._id,
              role:
                this.props.me &&
                this.props.me.role_id &&
                this.props.me.role_id.role_name &&
                this.props.me.role_id.role_name &&
                this.props.me.role_id.role_name === 'trial'
                  ? 'free-trial'
                  : this.props.me.role_id.role_name,
              location: payload.service_occurs_at,
              collect_payment: payload.payment,
              bookable: payload.isBooking
            }
          }
          segmentEventTrack(segmentData)
        } else {
          notification('error', this.t('settings.invalid-booking-slots'))
          await this.setState({ submitting: false })
        }
      }
      if (this.state.type === 'edit') {
        if (!this.state.slotError) {
          payload = { ...this.state.selectedItem, ...payload, ...{ __v: 0 } }
          payload.created_by = payload.created_by._id
          payload.old_user_id = this.props.serviceUSer.user_id
          payload.selectUser = this.state.selectUser

          await this.props.UpdateService({ _id: payload._id, data: payload }, resetForm)
        } else {
          notification('error', this.t('settings.invalid-booking-slots'))
          await this.setState({ submitting: false })
        }
      }
    }
  }
  durationToMinutes(duration) {
    const arr = duration.split(':')
    const hr = Number(arr[0])
    const min = Number(arr[1])
    return hr * 60 + min
  }
  DurationtoString(item) {
    let hr = Math.floor(item / 60)
    let mn = item % 60
    if (hr.toString().length === 1) {
      hr = `0${hr}`
    }
    if (mn.toString().length === 1) {
      mn = `0${mn}`
    }
    return `${hr}:${mn}`
  }
  handleImageModal(item) {
    if (item === 'SERVICE IMAGE') {
      this.setState({ openMediaLibraryServiceImage: true })
    } else if (item === 'REMINDER IMAGE') {
      this.setState({ openMediaLibraryReminderImage: true })
    }
  }

  async onServiceImageSuccess(mediaitem) {
    this.setState({
      service_image: mediaitem[0].fileUrl,
      openMediaLibraryServiceImage: false
    })
  }
  async onReminderImageSuccess(mediaitem) {
    this.setState({
      reminder_image: mediaitem[0].fileUrl,
      openMediaLibraryReminderImage: false
    })
  }
  async handleHoursChange(businessHours) {
    await this.setState({ reenitialiseStatus: false, businessHours: businessHours })
  }
  async handleTimeChange(setFieldValue, data, field) {
    const newdata = this.durationToMinutes(data)
    const selectedItem = { ...this.state.selectedItem }
    selectedItem.duration = newdata
    await this.setState({ selectedItem: selectedItem })
  }
  async onRemoveReminderTime(setFieldValue, values, index) {
    const keyArray = [...values.appointment_reminder_time_new]
    keyArray.splice(index, 1)
    if (keyArray.length === 0) {
      setFieldValue('appointment_reminder_flag', false)
      const selectedItem = { ...this.state.selectedItem }
      selectedItem.appointment_reminder_time_new = [{ hour: '00', min: '00', value: '00' }]
      selectedItem.appointment_reminder_flag = false
      await this.setState({ selectedItem: selectedItem })
    } else {
      const selectedItem = { ...this.state.selectedItem }
      selectedItem.appointment_reminder_time_new = keyArray
      selectedItem.appointment_reminder_flag = true
      await this.setState({ selectedItem: selectedItem })
    }
  }
  showCustomHoursModal() {
    this.setState({ showBookingHoursModal: true })
  }
  async removeBusinessHours() {
    const selectedItem = { ...this.state.selectedItem }
    selectedItem.business_hours = defaultHours
    selectedItem.is_business_hours = true
    await this.setState({ selectedItem: selectedItem })
  }
  closeCustomHoursModal() {
    this.setState({ showBookingHoursModal: false })
  }
  async getBusinessHours(businessHours) {
    const selectedItem = { ...this.state.selectedItem }
    selectedItem.business_hours = await this.bussinessHoursFormattingFN(businessHours)
    selectedItem.is_business_hours = false
    this.setState({ selectedItem: selectedItem, businessHours: businessHours })
  }
  selectValue(setFieldValue, field, value) {
    setFieldValue(field, value)
    const selectedItem = { ...this.state.selectedItem }
    selectedItem[field] = value
    this.setState({ selectedItem: selectedItem })
  }
  handleReminderTimeChange(setFieldValue, fields, index, value) {
    const arr = value.split(':')
    const hr = Number(arr[0])
    const min = Number(arr[1])
    const newdata = { hour: hr.toString(), min: min.toString(), value: this.durationToMinutes(value) }
    const allReminderTimes = fields
    allReminderTimes[index] = newdata
    const selectedItem = { ...this.state.selectedItem }
    selectedItem.appointment_reminder_time_new = allReminderTimes
    this.setState({ selectedItem: selectedItem })
  }
  async setPaymentDueType(setFieldValue, value) {
    const selectedItem = { ...this.state.selectedItem }
    if (value === 'partial' || value === 'none') {
      selectedItem.allow_partial_payment = true
    } else {
      selectedItem.allow_partial_payment = false
    }
    if (value === 'none') {
      selectedItem.minimum_payment_amount = 0
      selectedItem.minimum_payment_percentage = 0
      selectedItem.minimum_payment_type = 'amount'
    } else if (value === 'partial') {
      selectedItem.minimum_payment_amount = ''
      selectedItem.minimum_payment_percentage = ''
      selectedItem.minimum_payment_type = 'amount'
    }
    await this.setState({ selectedItem: selectedItem })
  }
  getAssignedUser(userId, optArray) {
    const user = optArray.filter((item) => item.value === userId)
    if (user.length && user[0].label) {
      return user[0].label
    } else {
      const defaultUser = optArray.find((item) => item.isDefault === true)
      return defaultUser.label
    }
  }
  getUserAvatar(userid, optArray) {
    const user = optArray.filter((item) => item.value === userid)
    if (user.length && user[0].profile_picture) {
      return user[0].profile_picture
    } else {
      return 'https://dufzo4epsnvlh.cloudfront.net/image/user_avatar.svg'
    }
  }
  onSelectUser(user) {
    this.setState({ selectUser: user, serviceUser: user.value })
  }
  async selectMinimumAmountType(value) {
    let type = ''
    if (value === 'percentage') {
      type = 'percentage'
    } else if (value === 'amount') {
      type = 'amount'
    }
    const selectedItem = { ...this.state.selectedItem }
    selectedItem.minimum_payment_type = type
    await this.setState({ selectedItem: selectedItem })
  }
  getUserNotifyStatus(values) {
    if (values && values.notify_owner_email && values.notify_owner_sms) {
      return 'Email & SMS'
    } else if (values && values.notify_owner_email && !values.notify_owner_sms) {
      return 'Email'
    } else if (values && !values.notify_owner_email && values.notify_owner_sms) {
      return 'SMS'
    } else if (values && !values.notify_owner_email && !values.notify_owner_sms) {
      return 'No'
    }
    return 'No'
  }
  updateField(field, value) {
    const selectedItem = { ...this.state.selectedItem }
    selectedItem[field] = value
    this.setState({ selectedItem: selectedItem })
  }
  resizeTextArea(e) {
    e.target.style.height = this.state.textAreaInitialHeight
    // Get the computed styles for the element
    const computed = window.getComputedStyle(e.target)

    // Calculate the height
    const height =
      parseInt(computed.getPropertyValue('border-top-width'), 10) +
      e.target.scrollHeight +
      parseInt(computed.getPropertyValue('border-bottom-width'), 10)

    e.target.style.height = `${height}px`
    height > 100 ? this.setState({ textAreaHeightExceed: true }) : this.setState({ textAreaHeightExceed: false })
  }
  getDueDropdownLabel() {
    let label = ''
    const { allowPartialPayment, minimumPaymentAmount, minimumPaymentType, minimumPaymentPercentage } =
      this.state.selectedItem
    if (
      allowPartialPayment &&
      (minimumPaymentType === 'amount' || minimumPaymentType === 'percentage') &&
      (minimumPaymentAmount !== 0 || minimumPaymentPercentage !== 0)
    ) {
      label = amountDueTypes[2].label
    } else if (allowPartialPayment && minimumPaymentType === 'amount' && minimumPaymentAmount === 0) {
      label = amountDueTypes[0].label
    } else {
      label = amountDueTypes[1].label
    }
    return label
  }
  isNonePayment() {
    const { allowPartialPayment, minimumPaymentAmount, minimumPaymentType, minimumPaymentPercentage } =
      this.state.selectedItem
    if (
      allowPartialPayment &&
      (minimumPaymentType === 'amount' || minimumPaymentType === 'percentage') &&
      (minimumPaymentAmount !== 0 || minimumPaymentPercentage !== 0)
    ) {
      return false
    } else if (allowPartialPayment && minimumPaymentType === 'amount' && minimumPaymentAmount === 0) {
      return true
    } else {
      return false
    }
  }
  render() {
    const t = this.t
    return (
      <Popup
        open={this.state.popUPOpen}
        title={this.state.type === 'add' ? t('common.add-service') : t('services.edit-service')}
        hideFooter={true}
        type="default"
        overrideForm={true}
        id="modalAddService"
        modalBackdropClicked={this.closeModal.bind(this)}>
        {this.state.openMediaLibraryServiceImage ? (
          <MediaLibraryPopup
            open={this.state.openMediaLibraryServiceImage}
            onSubmit={this.onServiceImageSuccess.bind(this)}
            onCancel={() => this.setState({ openMediaLibraryServiceImage: !this.state.openMediaLibraryServiceImage })}
            id="modalServiceImageMediaLibrary"
            multiple={true}
            type={['image']}
            showShapes={true}
            hideImages={true}
            crop={true}
          />
        ) : null}
        {this.state.openMediaLibraryReminderImage ? (
          <MediaLibraryPopup
            open={this.state.openMediaLibraryReminderImage}
            onSubmit={this.onReminderImageSuccess.bind(this)}
            onCancel={() => this.setState({ openMediaLibraryReminderImage: !this.state.openMediaLibraryReminderImage })}
            id="modalReminderImageMediaLibrary"
            multiple={true}
            type={['image']}
            showShapes={true}
            hideImages={true}
            crop={true}
          />
        ) : null}
        {this.state.bookingStatus && !this.props.isFromInstatSite ? (
          <Formik
            validateOnChange={true}
            validateOnBlur={false}
            enableReinitialize={true}
            initialValues={{
              title:
                this.state.selectedItem && Object.keys(this.state.selectedItem) !== 0 && this.state.selectedItem.title
                  ? this.state.selectedItem.title
                  : '',
              duration:
                this.state.selectedItem &&
                Object.keys(this.state.selectedItem) !== 0 &&
                (this.state.selectedItem.duration === null || typeof this.state.selectedItem.duration === 'undefined')
                  ? '60'
                  : this.state.selectedItem.duration,
              descripton:
                this.state.selectedItem &&
                Object.keys(this.state.selectedItem) !== 0 &&
                this.state.selectedItem.descripton
                  ? this.state.selectedItem.descripton
                  : '',
              block_off_time:
                this.state.selectedItem &&
                Object.keys(this.state.selectedItem) !== 0 &&
                this.state.selectedItem.block_off_time
                  ? this.state.selectedItem.block_off_time
                  : '0',
              dateRange:
                this.state.selectedItem &&
                Object.keys(this.state.selectedItem) !== 0 &&
                this.state.selectedItem.dateRange
                  ? this.state.selectedItem.dateRange
                  : 30,
              startTimeInc:
                this.state.selectedItem &&
                Object.keys(this.state.selectedItem) !== 0 &&
                this.state.selectedItem.startTimeInc
                  ? this.state.selectedItem.startTimeInc
                  : 15,
              missedFee:
                this.state.selectedItem &&
                Object.keys(this.state.selectedItem) !== 0 &&
                this.state.selectedItem.missedFee
                  ? this.state.selectedItem.missedFee
                  : '',
              // appointment_reminder_flag: this.state.selectedItem && Object.keys(this.state.selectedItem) !== 0 && this.state.selectedItem.appointment_reminder_flag !== (null || undefined) ? this.state.selectedItem.appointment_reminder_flag : false,
              // appointment_reminder_time_new: this.state.selectedItem && Object.keys(this.state.selectedItem) !== 0 && this.state.selectedItem.appointment_reminder_time_new && this.state.selectedItem.appointment_reminder_time_new.length ? this.state.selectedItem.appointment_reminder_time_new : [{ hour: "00", min: "00", value: "00" }],
              appointment_calendar_color:
                this.state.selectedItem &&
                Object.keys(this.state.selectedItem) !== 0 &&
                this.state.selectedItem.appointment_calendar_color
                  ? this.state.selectedItem.appointment_calendar_color
                  : '#cccccc',
              notify_owner:
                this.state.selectedItem &&
                Object.keys(this.state.selectedItem) !== 0 &&
                this.state.selectedItem.notify_owner !== (null || undefined)
                  ? this.state.selectedItem.notify_owner
                  : true,
              notify_owner_email:
                this.state.selectedItem &&
                Object.keys(this.state.selectedItem) !== 0 &&
                this.state.selectedItem.notify_owner_email !== (null || undefined)
                  ? this.state.selectedItem.notify_owner_email
                  : true,
              notify_owner_sms:
                this.state.selectedItem &&
                Object.keys(this.state.selectedItem) !== 0 &&
                this.state.selectedItem.notify_owner_sms !== (null || undefined)
                  ? this.state.selectedItem.notify_owner_sms
                  : false,
              price:
                this.state.selectedItem && Object.keys(this.state.selectedItem) !== 0 && this.state.selectedItem.price
                  ? this.state.selectedItem.price
                  : '',
              minimum_payment_type:
                this.state.selectedItem &&
                Object.keys(this.state.selectedItem) !== 0 &&
                this.state.selectedItem.minimum_payment_type
                  ? this.state.selectedItem.minimum_payment_type
                  : 'percentage',
              minimum_payment_amount:
                this.state.selectedItem &&
                Object.keys(this.state.selectedItem) !== 0 &&
                this.state.selectedItem.minimum_payment_amount
                  ? this.state.selectedItem.minimum_payment_amount
                  : '',
              minimum_payment_percentage:
                this.state.selectedItem &&
                Object.keys(this.state.selectedItem) !== 0 &&
                this.state.selectedItem.minimum_payment_percentage
                  ? this.state.selectedItem.minimum_payment_percentage
                  : '',
              free_consultation:
                this.state.selectedItem &&
                Object.keys(this.state.selectedItem) !== 0 &&
                this.state.selectedItem.free_consultation !== (null || undefined)
                  ? this.state.selectedItem.free_consultation
                  : false,
              is_business_hours:
                this.state.selectedItem &&
                Object.keys(this.state.selectedItem) !== 0 &&
                this.state.selectedItem.is_business_hours !== (null || undefined)
                  ? this.state.selectedItem.is_business_hours
                  : true,
              business_hours:
                this.state.selectedItem &&
                Object.keys(this.state.selectedItem) !== 0 &&
                this.state.selectedItem.business_hours &&
                Object.keys(this.state.selectedItem.business_hours).length !== 0
                  ? this.sortArrayFunction(this.state.selectedItem.business_hours)
                  : defaultHours,
              user_id: this.state.serviceUser
                ? this.state.serviceUser
                : this.props.me && this.props.me._id
                ? this.props.me._id
                : '',
              allow_partial_payment:
                this.state.selectedItem &&
                Object.keys(this.state.selectedItem) !== 0 &&
                this.state.selectedItem.allow_partial_payment !== (null || undefined)
                  ? this.state.selectedItem.allow_partial_payment
                  : false,
              payment:
                this.state.selectedItem &&
                Object.keys(this.state.selectedItem) !== 0 &&
                this.state.selectedItem.payment !== (null || undefined)
                  ? this.state.selectedItem.payment
                  : true,
              isBooking:
                this.state.selectedItem &&
                Object.keys(this.state.selectedItem) !== 0 &&
                this.state.selectedItem.isBooking !== (null || undefined)
                  ? this.state.selectedItem.isBooking
                  : false,
              service_occurs_at:
                this.state.selectedItem &&
                Object.keys(this.state.selectedItem) !== 0 &&
                this.state.selectedItem.service_occurs_at
                  ? this.state.selectedItem.service_occurs_at
                  : this.props.businessSettings && this.props.businessSettings.door_delivery
                  ? serviceLocations[1].value
                  : serviceLocations[0].value,
              isNone: !!(
                this.state.selectedItem &&
                this.state.selectedItem.allow_partial_payment &&
                this.state.selectedItem.minimum_payment_amount === 0
              )
            }}
            validationSchema={Yup.object().shape({
              title: Yup.string().required(t('bookings.required')),
              duration: Yup.string()
                .test('duration', t('bookings.required'), (value) => value !== '00:00')
                .required(t('bookings.required'))
                .nullable(),
              descripton: Yup.string().required(t('bookings.required')),
              user_id: Yup.string().when('isBooking', {
                is: true,
                then: Yup.string().required(t('bookings.required'))
              }),
              block_off_time: Yup.string().required(t('bookings.required')),
              // price:Yup.string().required("Required"),
              minimum_payment_percentage: Yup.string().test(
                'minimum_payment_percentage',
                t('bookings.required'),
                function (value) {
                  const { minimumPaymentType, allowPartialPayment } = this.parent
                  if (allowPartialPayment && minimumPaymentType === 'percentage') {
                    return value
                  }
                  return true
                }
              ),
              minimum_payment_amount: Yup.string().test(
                'minimum_payment_amount',
                t('bookings.required'),
                function (value) {
                  const { minimumPaymentType, allowPartialPayment, isNone } = this.parent
                  if (allowPartialPayment && minimumPaymentType === 'amount' && !isNone) {
                    return value
                  }
                  return true
                }
              )
            })}
            onReset={this.handleCancel.bind(this)}
            onSubmit={this.handleSubmit.bind(this)}
            render={({ values, setFieldValue, resetForm }) => {
              values.minimum_payment_amount = values.price ? values.minimum_payment_amount : ''
              const { me } = this.props
              const opt1 = me
                ? {
                    value: me._id,
                    label: me.full_name,
                    email: me.user_email,
                    profile_picture: me.profile_picture,
                    isDefault: true
                  }
                : {}
              const optArray = this.props.assignedUser
                ? [
                    opt1,
                    ...this.props.assignedUser.map((item, index) => {
                      let name = item.first_name ? item.first_name : ''
                      name += item.last_name ? ` ${item.last_name}` : ''
                      return {
                        value: item._id,
                        label: name,
                        email: item.user_email,
                        profile_picture: item.profile_picture ? item.profile_picture : ''
                      }
                    })
                  ]
                : []
              return (
                <Form id="frm_addService" className={`common-add-service-modal mt-10 ${styles['add-service-modal']}`}>
                  <button type="reset" id="closeIcon" className="close custom-modal-close-button remove-modal-close">
                    <span aria-hidden="true"></span>
                  </button>
                  {this.state.dataFetching ? (
                    <div
                      className={`position-absolute top-0 right-0 z-index-2 bottom-0 left-0 d-flex align-items-center justify-content-center ${styles['form-loader']}`}>
                      <img src="https://dufzo4epsnvlh.cloudfront.net/image/loader-dot.svg" alt="loader" />
                    </div>
                  ) : null}
                  <div className="row no-gutters">
                    <div className="col-12">
                      <div className="form-group">
                        {/* Customer facing details */}
                        <label className="label-text text-uppercase">{t('services.customer-facing-details')}</label>
                        <div className="border rounded mb-15">
                          <div className="d-flex align-items-center border-bottom">
                            <div className={`${styles['b-card-item-small']}`}>
                              <div className="d-block h-100 px-15">
                                <div className="d-flex align-items-center">
                                  <span className="line-height-normal">{t('services.service-name')}</span>
                                  <span className="star text-danger position-relative">*</span>
                                </div>
                                <ErrorMessage
                                  name="title"
                                  component="span"
                                  id="lbl_serviceNameError"
                                  className="form-error mt-3 mb-5 ml-0"
                                />
                              </div>
                            </div>
                            <div className={`${styles['b-card-item-large']}`}>
                              <Field
                                id="frm_addService_txtServiceName"
                                type="text"
                                className={`form-control form-control-lg border-0 text-truncate ${styles['custom-placeholder-color']}`}
                                placeholder={t('services.enter-service-name')}
                                name="title"
                                value={values.title}
                                onChange={(e) => {
                                  const { value } = e.target
                                  setFieldValue('title', value)
                                }}
                                onBlur={(e) => {
                                  const { value } = e.target
                                  this.updateField('title', value)
                                }}
                              />
                            </div>
                          </div>
                          <div className="d-flex align-items-center border-bottom">
                            <div className={`${styles['b-card-item-small']}`}>
                              <div className="d-block h-100 px-15">
                                <div className="d-flex align-items-center">
                                  <span className="line-height-normal">{t('activities.description')}</span>
                                  <span className="star text-danger position-relative">*</span>
                                </div>
                                <ErrorMessage
                                  name="descripton"
                                  id="lbl_serviceDescriptionError"
                                  component="span"
                                  className="form-error mt-3 mb-5 ml-0"
                                />
                              </div>
                            </div>
                            <div className={`${styles['b-card-item-large']}`}>
                              <textarea
                                id="frm_addService_txtServiceDescription"
                                // component="textarea"
                                className={`form-control form-control-lg border-0 pt-10 ${styles['is-resize-none']} ${styles['custom-placeholder-color']}`}
                                placeholder={t('services.enter-service-description')}
                                name="descripton"
                                value={values.descripton}
                                style={{ maxHeight: 100 }}
                                onKeyUp={this.resizeTextArea.bind(this)}
                                onChange={(e) => {
                                  const { value } = e.target
                                  // this.updateField("descripton",value)
                                  setFieldValue('descripton', value)
                                }}
                                onBlur={(e) => {
                                  const { value } = e.target
                                  this.updateField('descripton', value)
                                }}
                              />
                            </div>
                          </div>
                          <div className="d-flex align-items-center border-bottom">
                            <div className={`${styles['b-card-item-small']}`}>
                              <div className="d-block h-100 px-15">
                                <div className="d-flex align-items-center">
                                  <span className="line-height-normal">{t('services.price')}</span>
                                  {/* <span className="star text-danger position-relative">*</span> */}
                                </div>
                                {/* <ErrorMessage name="price" id="lbl_servicePriceError" component="span" className="form-error mt-3 mb-5 ml-0" /> */}
                              </div>
                            </div>
                            <div className={`${styles['b-card-item-large']}`}>
                              <Field
                                id="frm_addService_txtPayemntAmount"
                                type="text"
                                className={'form-control form-control-lg border-0 text-secondary'}
                                placeholder={t('services.service-charge')}
                                name="price"
                                maxLength={config.amountFieldLength}
                                onChange={(e) => {
                                  const { value } = e.target
                                  const regex = /^(0*[0-9][0-9]*(\.[0-9]{0,2})?|0*\.[0-9]{0,2})$/
                                  if (regex.test(value.toString()) || value.length === 0) {
                                    this.updateField('price', value)
                                  }
                                }}
                              />
                            </div>
                          </div>
                          <div className="d-flex align-items-center border-bottom">
                            <div className={`${styles['b-card-item-small']}`}>
                              <div className="d-block h-100 px-15">
                                <div className="d-flex align-items-center">
                                  <span className="line-height-normal">{t('services.duration')}</span>
                                  <span className="star text-danger position-relative">*</span>
                                </div>
                                <ErrorMessage
                                  name="duration"
                                  id="lbl_serviceDurationError"
                                  component="span"
                                  className="form-error mt-3 mb-5 ml-0"
                                />
                              </div>
                            </div>
                            <div className={`${styles['b-card-item-large']} px-15`}>
                              <TimeInput
                                time={this.DurationtoString(values.duration)}
                                handleChange={this.handleTimeChange.bind(this, setFieldValue)}
                                field="duration"
                                placeholder="00:00"
                                id="frm_addService_txtServiceDuration"
                                isTimeLimited={true}
                              />
                            </div>
                          </div>
                          <div className="d-flex align-items-center border-bottom">
                            <div className={`${styles['b-card-item-small']}`}>
                              <div className="d-flex align-items-center h-100 px-15">
                                <span className="mr-10 line-height-normal">{t('services.missed-appt-fee')}</span>
                                <div className="cursor-pointer">
                                  <Tooltip
                                    className="cursor-pointer"
                                    position="top"
                                    message={t('services.set-the-fee-you-charge-for-missed-appointment')}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className={`${styles['b-card-item-large']}`}>
                              <Field
                                id="frm_addService_txtMissedAppFee"
                                type="text"
                                className={'form-control form-control-lg border-0 text-secondary'}
                                placeholder={t('services.enter-missed-appt-fee')}
                                name="missedFee"
                                value={values.missedFee}
                                maxLength={config.amountFieldLength}
                                onChange={(e) => {
                                  const { value } = e.target
                                  const regex = /^(0*[1-9][0-9]*(\.[0-9]{0,2})?|0*\.[0-9]{0,2})$/
                                  if (regex.test(value.toString()) || value.length === 0) {
                                    this.updateField('missedFee', value)
                                  }
                                }}
                              />
                            </div>
                          </div>
                          <div className="d-flex align-items-center border-bottom">
                            <div className={`${styles['b-card-item-small']}`}>
                              <div className="d-flex align-items-center h-100 px-15">
                                <span className="line-height-normal mr-10">{t('services.service-occurs-at')}</span>
                              </div>
                            </div>
                            <div
                              className={`${styles['b-card-item-large']} d-flex pl-15 align-items-center justify-content-between position-relative`}>
                              <span className="line-height-normal">
                                {values.service_occurs_at && values.service_occurs_at === 'business_address'
                                  ? t('services.my-business-location')
                                  : values.service_occurs_at === 'customer_address'
                                  ? t('services.customers-address')
                                  : ''}
                              </span>
                              <div
                                onClick={() => this.setState({ showLocationList: true })}
                                className={
                                  'dropdown btn border-0 b-manage-dropdown right-0 left-0 cursor-pointer position-absolute'
                                }
                                id="">
                                <div
                                  className="dropdown-toggle dropdown-toggle-manage btn-manage w-100 bg-transparent text-right"
                                  data-toggle="dropdown">
                                  <i className={`btn-icon ml-10 manage-icon-arrow ${styles['icon-dropdown-arrow']}`}>
                                    <Icons name="arrowDownThin" />
                                  </i>
                                </div>
                                {this.state.showLocationList ? (
                                  <OnClickOutside handleClickOutside={() => this.setState({ showLocationList: false })}>
                                    <ul className="dropdown-menu show width-200 dropdown-menu-manage dropdown-menu-right max-height-200 overflow-y-scrollbar">
                                      {serviceLocations.map((item, index) => (
                                        <li
                                          key={index}
                                          className="primary-font px-15"
                                          onClick={(e) => {
                                            e.stopPropagation()
                                            this.selectValue(setFieldValue, 'service_occurs_at', item.value)
                                            this.setState({ showLocationList: false })
                                          }}>
                                          <span>{item.label}</span>
                                        </li>
                                      ))}
                                    </ul>
                                  </OnClickOutside>
                                ) : null}
                              </div>
                            </div>
                          </div>
                          <div className="d-flex align-items-center position-relative">
                            <div className={`${styles['b-card-item-small']}`}>
                              <div className="d-flex align-items-center h-100 px-15">
                                <span className="line-height-normal">{t('services.service-image')}</span>
                              </div>
                            </div>
                            <div
                              className={`d-flex align-items-center justify-content-between px-15 ${styles['b-card-item-large']}`}>
                              {!this.state.service_image ? (
                                <span className="upload-info">{t('services.none')}</span>
                              ) : (
                                <div className={'d-flex align-items-center '}>
                                  <div className={`d-flex align-items-center ${styles['b-profile-image']}`}>
                                    <div className={'d-flex align-items-center position-relative'}>
                                      <div className={`${styles['service-image']}`}>
                                        <figure className={`rounded-circle ${styles['image-figure']}`}>
                                          <img
                                            className={`rounded-circle ${styles['image-cover']}`}
                                            src={`${
                                              this.state.service_image
                                                ? generateImageUrl(this.state.service_image, 'micro')
                                                : 'https://dufzo4epsnvlh.cloudfront.net/image/user_avatar.svg'
                                            }`}
                                            alt=""
                                          />
                                        </figure>
                                      </div>
                                      <button
                                        type="button"
                                        className={`btn rounded-circle p-0 d-flex align-items-center justify-content-center position-absolute ${styles['btn-trash']}`}>
                                        <i
                                          onClick={() => this.setState({ service_image: '' })}
                                          className={`btn-icon d-flex mt-1 ${styles['image-trash']}`}>
                                          <Icons name="trash" />
                                        </i>
                                      </button>
                                    </div>
                                  </div>
                                  <div className={` ${styles['b-profile-image']}`}>
                                    <div className={`ml-10 ${styles['b-enlarge-image']}`}>
                                      <span type="button" className={'fz-12 primary-font cursor-pointer'}>
                                        {t('services.enlarge-image')}
                                      </span>
                                      <div
                                        className={`position-absolute bg-white shadow-lg rounded ${styles['service-image']} ${styles['enlarge-image']}`}>
                                        <figure className={` ${styles['image-figure']}`}>
                                          <img
                                            className={` ${styles['image-cover']}`}
                                            src={`${
                                              this.state.service_image
                                                ? generateImageUrl(this.state.service_image, 'profile')
                                                : 'https://dufzo4epsnvlh.cloudfront.net/image/user_avatar.svg'
                                            }`}
                                            alt=""
                                          />
                                        </figure>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                              <button
                                className={`btn btn-lg pr-0 border-0 ${styles['image-button-border']}`}
                                id="frm_addService_btnServiceImage"
                                type="button"
                                onClick={() => this.handleImageModal('SERVICE IMAGE')}>
                                <i className={`btn-icon d-flex ${styles['icon-export']}`}>
                                  <Icons name="export" />
                                </i>
                              </button>
                            </div>
                          </div>
                        </div>
                        {/* end Customer facing details */}
                        {/* Bookable by Customers */}
                        <div id="accordion" role="tablist" className="mb-15">
                          <div className="card">
                            <div
                              className={`card-header d-flex align-items-center justify-content-between px-15 py-3 border-0 ${styles['accordion-card-header']}`}
                              role="tab"
                              id="headingBookable">
                              <div className="d-flex align-items-center">
                                <h4 className="mb-0 fz-14 mr-10">{t('services.bookable-by-customers')}</h4>
                                <div className="cursor-pointer position-relative top-minus-1">
                                  <Tooltip
                                    position="top"
                                    message={t('services.allow-customers-to-book-this-service-via-booking')}
                                  />
                                </div>
                              </div>
                              <div className="form-switch form-group mb-0">
                                <button
                                  className="btn pr-0"
                                  type="button"
                                  data-toggle="collapse"
                                  data-target="#collapseBookableByCustomers"
                                  aria-expanded="false"
                                  aria-controls="collapseBookableByCustomers">
                                  <label>
                                    <Field
                                      type="checkbox"
                                      className="form-control form-control-lg"
                                      checked={values.isBooking}
                                      name="isBooking"
                                      onChange={(event) => {
                                        this.updateField('isBooking', event.target.checked)
                                      }}
                                    />
                                    <span className="checkbox-icon "></span>
                                  </label>
                                </button>
                              </div>
                            </div>
                            <div
                              id="collapseBookableByCustomers"
                              className={`collapse  ${values.isBooking ? 'show' : ''}`}
                              role="tabpanel"
                              aria-labelledby="headingBookable">
                              <div className="card-body p-0">
                                <div className="d-flex align-items-center border-top py-5 py-sm-0 position-relative">
                                  <div className={`w-50 d-flex align-items-center ${styles['card-row-item-height']}`}>
                                    <div className="d-flex align-items-center h-100 px-15">
                                      <span className="line-height-normal">{t('services.prep-time')}</span>
                                    </div>
                                  </div>
                                  <div
                                    className={`d-flex align-items-center justify-content-between px-15 w-50 ${styles['card-row-item-height']}`}>
                                    <span className="line-height-normal">
                                      {values.block_off_time !== '0'
                                        ? `${values.block_off_time} minutes`
                                        : t('services.none')}
                                    </span>
                                    <div
                                      onClick={() => this.setState({ showPrepList: true })}
                                      className={
                                        'dropdown btn border-0 b-manage-dropdown position-absolute right-0 left-0 cursor-pointer'
                                      }
                                      id="">
                                      <div
                                        className="dropdown-toggle dropdown-toggle-manage btn-manage w-100 bg-transparent text-right"
                                        data-toggle="dropdown">
                                        <i
                                          className={`btn-icon ml-10 manage-icon-arrow ${styles['icon-dropdown-arrow']}`}>
                                          <Icons name="arrowDownThin" />
                                        </i>
                                      </div>
                                      {this.state.showPrepList ? (
                                        <OnClickOutside
                                          handleClickOutside={() => this.setState({ showPrepList: false })}>
                                          <ul className="dropdown-menu show dropdown-menu-manage dropdown-menu-right max-height-200 overflow-y-scrollbar">
                                            {prepTimes.map((time, index) => (
                                              <li
                                                key={index}
                                                className="primary-font px-15"
                                                onClick={(e) => {
                                                  e.stopPropagation()
                                                  this.selectValue(setFieldValue, 'block_off_time', time.value)
                                                  this.setState({ showPrepList: false })
                                                }}>
                                                <span>{time.label}</span>
                                              </li>
                                            ))}
                                          </ul>
                                        </OnClickOutside>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                                <div className="d-flex align-items-center border-top py-5 py-sm-0">
                                  <div className={`w-50 d-flex align-items-center ${styles['card-row-item-height']}`}>
                                    <div className="d-flex align-items-center h-100 px-15">
                                      <span className="line-height-normal mr-10">{t('services.date-range')}</span>
                                      <div className="cursor-pointer position-relative top-minus-1">
                                        <Tooltip
                                          position="top"
                                          message={t('services.set-number-of-days-a-booking-can-be-made-in-the-future')}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className={`d-flex align-items-center justify-content-between px-15 w-50 position-relative ${styles['card-row-item-height']}`}>
                                    <span className="line-height-normal">{values.dateRange} days</span>
                                    <div
                                      onClick={() => this.setState({ showDateList: true })}
                                      className={
                                        'dropdown btn border-0 b-manage-dropdown position-absolute right-0 left-0 cursor-pointer'
                                      }
                                      id="">
                                      <div
                                        className="dropdown-toggle dropdown-toggle-manage btn-manage w-100 bg-transparent text-right"
                                        data-toggle="dropdown">
                                        <i
                                          className={`btn-icon ml-10 manage-icon-arrow ${styles['icon-dropdown-arrow']}`}>
                                          <Icons name="arrowDownThin" />
                                        </i>
                                      </div>
                                      {this.state.showDateList ? (
                                        <OnClickOutside
                                          handleClickOutside={() => this.setState({ showDateList: false })}>
                                          <ul className="dropdown-menu show dropdown-menu-manage dropdown-menu-right max-height-200 overflow-y-scrollbar">
                                            {dateRanges.map((date, index) => (
                                              <li
                                                key={index}
                                                className="primary-font px-15"
                                                onClick={(e) => {
                                                  e.stopPropagation()
                                                  this.selectValue(setFieldValue, 'dateRange', date.value)
                                                  this.setState({ showDateList: false })
                                                }}>
                                                <span>{date.label}</span>
                                              </li>
                                            ))}
                                          </ul>
                                        </OnClickOutside>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                                <div className="d-flex align-items-center border-top py-5 py-sm-0">
                                  <div className={`w-50 d-flex align-items-center ${styles['card-row-item-height']}`}>
                                    <div className="d-flex align-items-center h-100 px-15">
                                      <span className="line-height-normal mr-10">
                                        {t('services.start-time-increments')}
                                      </span>
                                      <div className="cursor-pointer position-relative top-minus-1">
                                        <Tooltip
                                          position="top"
                                          message={t('services.show-available-start-times-in-specific-increments')}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className={`d-flex align-items-center justify-content-between px-15 w-50 position-relative ${styles['card-row-item-height']}`}>
                                    <span className="line-height-normal">{values.startTimeInc} minutes</span>
                                    <div
                                      onClick={() => this.setState({ showIncrementList: true })}
                                      className={
                                        'dropdown btn border-0 b-manage-dropdown position-absolute right-0 left-0 cursor-pointer'
                                      }
                                      id="">
                                      <div
                                        className="dropdown-toggle dropdown-toggle-manage btn-manage w-100 bg-transparent text-right"
                                        data-toggle="dropdown">
                                        <i
                                          className={`btn-icon ml-10 manage-icon-arrow ${styles['icon-dropdown-arrow']}`}>
                                          <Icons name="arrowDownThin" />
                                        </i>
                                      </div>
                                      {this.state.showIncrementList ? (
                                        <OnClickOutside
                                          handleClickOutside={() => this.setState({ showIncrementList: false })}>
                                          <ul className="dropdown-menu show dropdown-menu-manage dropdown-menu-right max-height-200 overflow-y-scrollbar">
                                            {startTimeIncrements.map((item, index) => (
                                              <li
                                                key={index}
                                                className="primary-font px-15"
                                                onClick={(e) => {
                                                  e.stopPropagation()
                                                  this.selectValue(setFieldValue, 'startTimeInc', item.value)
                                                  this.setState({ showIncrementList: false })
                                                }}>
                                                <span>{item.label}</span>
                                              </li>
                                            ))}
                                          </ul>
                                        </OnClickOutside>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                                <div className="d-flex align-items-center border-top py-5 py-sm-0">
                                  <div className={`w-50 d-flex align-items-center ${styles['card-row-item-height']}`}>
                                    <div className="d-flex align-items-center h-100 px-15">
                                      <span className="line-height-normal mr-10">
                                        {t('services.custom-booking-hours')}
                                      </span>
                                      <div className="cursor-pointer position-relative top-minus-1">
                                        <Tooltip
                                          position="top"
                                          message={t('services.set-custom-schedule-for-service-availability')}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className={`d-flex align-items-center justify-content-between px-15 w-50 ${styles['card-row-item-height']}`}>
                                    <button
                                      type="button"
                                      className="border-0 bg-white link-color px-0 line-height-normal text-left"
                                      onClick={this.showCustomHoursModal.bind(this)}>
                                      {values.is_business_hours
                                        ? t('services.add-custom-hours')
                                        : t('services.view-edit-custom-hours')}
                                    </button>
                                    {!values.is_business_hours ? (
                                      <Tooltip
                                        type="button"
                                        position="top"
                                        message={t('services.remove-custom-booking-hours')}>
                                        <i
                                          className={`btn-icon d-flex top-minus-1 ml-10 cursor-pointer ${styles['button-remove']}`}
                                          onClick={this.removeBusinessHours.bind(this)}>
                                          <Icons name="trashEmpty" />
                                        </i>
                                      </Tooltip>
                                    ) : null}
                                  </div>
                                </div>
                                {/* <div className="d-flex align-items-start border-top py-5 py-sm-0">
                                                                    <div className={`w-50 d-flex align-items-center ${styles["card-row-item-height"]}`}>
                                                                        <div className="d-flex align-items-center h-100 px-15">
                                                                            <span className="line-height-normal mr-10">Customer Reminder Time</span>
                                                                            <div className="cursor-pointer position-relative top-minus-1">
                                                                                <Tooltip position="top" message="Reminder time" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className={`d-flex align-items-center justify-content-between px-15 w-50 ${styles["card-row-item-height"]}`}>
                                                                        {!values.appointment_reminder_flag ?
                                                                            <button type="button" className="border-0 bg-white link-color px-0 line-height-normal text-left"
                                                                                onClick={() => this.updateField("appointment_reminder_flag", true)} >Add reminder time
                                                                            </button>
                                                                            : null}
                                                                        {values.appointment_reminder_flag ?
                                                                            <div className="w-100">
                                                                                {values.appointment_reminder_time_new.length !== 0 ? values.appointment_reminder_time_new.map((item, index) => (
                                                                                    <div key={index} className={`d-flex align-items-center justify-content-between ${styles["b-add-reminder-time"]}`}>
                                                                                        <div className="mr-10 d-flex align-items-center">
                                                                                            <TimeInput
                                                                                                time={this.DurationtoString(item.value)}
                                                                                                handleChange={this.handleReminderTimeChange.bind(this, setFieldValue, values.appointment_reminder_time_new, index)}
                                                                                                placeholder="00:00"
                                                                                                id={`frm_addService_txtReminder_${index}`}
                                                                                            />
                                                                                            <span className="line-height-normal">{index === 0 ? "before appt" : ""}</span>
                                                                                        </div>
                                                                                        <div className={`d-flex align-items-center h-100 ${styles["icon-styles"]}`}  >
                                                                                            <i onClick={(event) => { this.onRemoveReminderTime(setFieldValue, values, index) }} className={`btn-icon d-flex top-minus-1 mr-10 ${styles["button-remove"]}`}>
                                                                                                <Icons name="trashEmpty" />
                                                                                            </i>
                                                                                            {index === values.appointment_reminder_time_new.length - 1 ?
                                                                                                <div className="ml-auto">
                                                                                                    <Tooltip position="bottom" type="button" message="Add appoinment reminder time">
                                                                                                        <i onClick={() => {
                                                                                                            let value = [...values.appointment_reminder_time_new, { hour: "00", min: "00", value: "00" }]
                                                                                                            setFieldValue("appointment_reminder_time_new", (value))
                                                                                                            this.updateField("appointment_reminder_time_new", value)
                                                                                                        }} className={`btn-icon d-flex top-2 ${styles["button-add"]}`}>
                                                                                                            <Icons name="plusThin" />
                                                                                                        </i>
                                                                                                    </Tooltip>
                                                                                                </div> : null}
                                                                                        </div>
                                                                                    </div>
                                                                                )) : null}
                                                                            </div>
                                                                            : null}
                                                                    </div>
                                                                </div> */}
                                <div className="d-flex align-items-center border-top position-relative py-5 py-sm-0">
                                  <div className={`w-50 d-flex align-items-center ${styles['card-row-item-height']}`}>
                                    <div className="d-flex align-items-center h-100 px-15">
                                      <span className="mr-10 line-height-normal">{t('services.business-logo')}</span>
                                      <div className="cursor-pointer position-relative top-minus-1">
                                        <Tooltip
                                          position="top"
                                          message={t('services.display-your-logo-on-the-email-and-sms-reminders')}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className={`d-flex align-items-center justify-content-between px-15 w-50 ${styles['card-row-item-height']}`}>
                                    {!this.state.reminder_image ? (
                                      <span className="upload-info">{t('services.none')}</span>
                                    ) : (
                                      <div className={'d-flex align-items-center'}>
                                        <div
                                          className={`d-flex align-items-center position-relative ${styles['b-profile-image']}`}>
                                          <div className={`${styles['service-image']}`}>
                                            <figure className={`rounded-circle ${styles['image-figure']}`}>
                                              <img
                                                className={`rounded-circle ${styles['image-cover']}`}
                                                src={`${
                                                  this.state.reminder_image
                                                    ? generateImageUrl(this.state.reminder_image, 'micro')
                                                    : 'https://dufzo4epsnvlh.cloudfront.net/image/user_avatar.svg'
                                                }`}
                                                alt=""
                                              />
                                            </figure>
                                          </div>
                                          <button
                                            type="button"
                                            className={`btn rounded-circle p-0 d-flex align-items-center justify-content-center position-absolute ${styles['btn-trash']}`}>
                                            <i
                                              onClick={() => this.setState({ reminder_image: '' })}
                                              className={`btn-icon d-flex mt-1 ${styles['image-trash']}`}>
                                              <Icons name="trash" />
                                            </i>
                                          </button>
                                        </div>

                                        <div className={` ${styles['b-profile-image']}`}>
                                          <div className={`ml-10 ${styles['b-enlarge-image']}`}>
                                            <span type="button" className={'fz-12 primary-font cursor-pointer'}>
                                              {t('services.enlarge-image')}
                                            </span>
                                            <div
                                              className={`position-absolute bg-white shadow-lg rounded ${styles['service-image']} ${styles['enlarge-image']}`}>
                                              <figure className={` ${styles['image-figure']}`}>
                                                <img
                                                  className={` ${styles['image-cover']}`}
                                                  src={`${
                                                    this.state.reminder_image
                                                      ? generateImageUrl(this.state.reminder_image, 'profile')
                                                      : 'https://dufzo4epsnvlh.cloudfront.net/image/user_avatar.svg'
                                                  }`}
                                                  alt=""
                                                />
                                              </figure>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                    <button
                                      className={`btn btn-lg pr-0 border-0 ${styles['image-button-border']}`}
                                      id="frm_addService_btnReminderImage"
                                      type="button"
                                      onClick={() => this.handleImageModal('REMINDER IMAGE')}>
                                      <i className={`btn-icon ${styles['icon-export']}`}>
                                        <Icons name="export" />
                                      </i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* end Bookable by Customers */}
                        {/* Collect Payment at Checkout */}
                        {this.props &&
                        this.props.disabledProducts &&
                        !isDisabled('payment', this.props.disabledProducts) &&
                        this.props.me &&
                        this.props.me.account_settings &&
                        this.props.me.account_settings.payment &&
                        this.props.me.account_settings.payment.merchant_id ? (
                          <div id="collectPaymentAccordion" role="tablist" className="mb-15">
                            <div className="card">
                              <div
                                className={`card-header d-flex align-items-center justify-content-between px-15 py-3 border-0 ${styles['accordion-card-header']}`}
                                role="tab"
                                id="headingCollectPayment">
                                <div className="d-flex align-items-center">
                                  <h4 className="mb-0 fz-14 mr-10">{t('services.collect-payment-at-checkout')}</h4>
                                </div>
                                <div className="form-switch form-group mb-0">
                                  <button
                                    className="btn pr-0"
                                    type="button"
                                    disabled={values.price === '' || (values.price && parseFloat(values.price) === 0)}
                                    data-toggle="collapse"
                                    data-target="#collapseCollectPayment"
                                    aria-expanded="false"
                                    aria-controls="collapseCollectPayment">
                                    <label>
                                      <Field
                                        type="checkbox"
                                        className={'form-control form-control-lg'}
                                        checked={
                                          values.payment &&
                                          values.price &&
                                          parseFloat(values.price) > 0 &&
                                          values.price !== ''
                                        }
                                        name="payment"
                                        onChange={(event) => {
                                          this.updateField('payment', event.target.checked)
                                        }}
                                      />
                                      <span
                                        className={`checkbox-icon ${
                                          values.price === '' || (values.price && parseFloat(values.price) === 0)
                                            ? 'cursor-not-allowed'
                                            : ''
                                        }`}></span>
                                    </label>
                                  </button>
                                </div>
                              </div>
                              <div
                                id="collapseCollectPayment"
                                className={`collapse ${
                                  values.payment &&
                                  values.price &&
                                  parseFloat(values.price) !== 0 &&
                                  values.price !== ''
                                    ? 'show'
                                    : ''
                                }`}
                                role="tabpanel"
                                aria-labelledby="headingCollectPayment">
                                <div className="card-body p-0">
                                  <div className="d-flex align-items-center border-top py-5 py-sm-0 position-relative">
                                    <div className={`w-50 d-flex align-items-center ${styles['card-row-item-height']}`}>
                                      <div className="d-flex align-items-center h-100 px-15">
                                        <span className="line-height-normal">{t('services.amount-due')}</span>
                                      </div>
                                    </div>
                                    <div
                                      className={`d-flex align-items-center justify-content-between px-15 w-50 ${styles['card-row-item-height']}`}>
                                      {/* <span className="line-height-normal">{this.getDueDropdownLabel(values)}</span> */}
                                      <span className="line-height-normal">
                                        {values.allow_partial_payment
                                          ? t('services.deposit-partial-payment')
                                          : t('bookings.full-payment')}
                                      </span>
                                      <div
                                        onClick={() => this.setState({ showDueList: true })}
                                        className={
                                          'dropdown btn border-0 b-manage-dropdown position-absolute right-0 left-0 cursor-pointer'
                                        }
                                        id="">
                                        <div
                                          className="dropdown-toggle dropdown-toggle-manage btn-manage w-100 bg-transparent text-right"
                                          data-toggle="dropdown">
                                          <i
                                            className={`btn-icon ml-10 manage-icon-arrow ${styles['icon-dropdown-arrow']}`}>
                                            <Icons name="arrowDownThin" />
                                          </i>
                                        </div>
                                        {this.state.showDueList ? (
                                          <OnClickOutside
                                            handleClickOutside={() => this.setState({ showDueList: false })}>
                                            <ul className="dropdown-menu show dropdown-menu-manage dropdown-menu-right max-height-200 width-200 overflow-y-scrollbar">
                                              {amountDueTypes.map((type, index) => (
                                                <li
                                                  key={index}
                                                  className="primary-font px-15"
                                                  onClick={(e) => {
                                                    e.stopPropagation()
                                                    this.setPaymentDueType(setFieldValue, type.value)
                                                    this.setState({ showDueList: false })
                                                  }}>
                                                  <span>{type.label}</span>
                                                </li>
                                              ))}
                                            </ul>
                                          </OnClickOutside>
                                        ) : null}
                                      </div>
                                    </div>
                                  </div>
                                  {values.allow_partial_payment && !this.isNonePayment() ? (
                                    <div className="d-flex align-items-center border-top py-5 py-sm-0">
                                      <div
                                        className={`w-50 d-flex align-items-center ${styles['card-row-item-height']}`}>
                                        <div className="d-block h-100 px-15">
                                          <div className="d-flex align-items-center">
                                            <span className="line-height-normal">
                                              {values.allow_partial_payment
                                                ? t('services.deposit-partial-payment')
                                                : ''}
                                            </span>
                                            <span className="star text-danger position-relative mr-10">*</span>
                                            <div className="cursor-pointer position-relative top-minus-1">
                                              <Tooltip
                                                position="top"
                                                message={
                                                  values.minimum_payment_type === 'percentage' ||
                                                  values.minimum_payment_type === ''
                                                    ? t('services.enter-the-minimum-payment-in-percentage')
                                                    : t(
                                                        'services.allow-your-customers-to-partially-pay-for-a-service-up-front-by-entering-the-amount-or-percentage-here'
                                                      )
                                                }
                                              />
                                            </div>
                                          </div>
                                          <ErrorMessage
                                            name={
                                              values.minimum_payment_type === 'percentage'
                                                ? 'minimum_payment_percentage'
                                                : 'minimum_payment_amount'
                                            }
                                            component="span"
                                            id="lbl_serviceAssignedUser"
                                            className="form-error mt-3 mb-5 ml-0"
                                          />
                                        </div>
                                      </div>
                                      <div
                                        className={`d-flex align-items-center justify-content-between px-15 w-50 ${styles['card-row-item-height']}`}>
                                        {values.minimum_payment_type === 'percentage' ? (
                                          <Field
                                            disabled={!(values.price && values.price > 0)}
                                            id="frm_addService_txtPartialPayemnt"
                                            type="number"
                                            className={`form-control form-control-lg px-0 border-0 bg-white ${styles['field-normal-width']}`}
                                            placeholder="0"
                                            value={values.minimum_payment_percentage}
                                            name="minimum_payment_percentage"
                                            onChange={(e) => {
                                              if (
                                                e.target.value === '' ||
                                                (e.target.value > 0 && e.target.value <= 100)
                                              ) {
                                                this.updateField('minimum_payment_percentage', e.target.value)
                                              }
                                            }}
                                          />
                                        ) : (
                                          <Field
                                            disabled={!(values.price && values.price > 0)}
                                            id="frm_addService_txtPartialPayemnt"
                                            type="number"
                                            className={`form-control form-control-lg px-0 border-0 bg-white ${styles['field-normal-width']}`}
                                            placeholder="0"
                                            value={values.minimum_payment_amount}
                                            name="minimum_payment_amount"
                                            onChange={(e) => {
                                              if (
                                                e.target.value === '' ||
                                                (e.target.value > 0 &&
                                                  parseFloat(e.target.value) <= parseFloat(values.price))
                                              ) {
                                                this.updateField('minimum_payment_amount', e.target.value)
                                              }
                                            }}
                                          />
                                        )}
                                        <div className={'d-flex align-items-center'}>
                                          <span>
                                            {values.minimum_payment_type === 'amount'
                                              ? '$'
                                              : values.minimum_payment_type === 'percentage'
                                              ? '%'
                                              : '$'}
                                          </span>
                                          <div
                                            onClick={() => this.setState({ showPaymentTypeList: true })}
                                            className={'dropdown btn border-0 b-manage-dropdown pr-0 pl-0'}
                                            id="">
                                            <div
                                              className="dropdown-toggle dropdown-toggle-manage btn-manage w-100 bg-transparent"
                                              data-toggle="dropdown">
                                              <i
                                                className={`btn-icon ml-10 manage-icon-arrow ${styles['icon-dropdown-arrow']}`}>
                                                <Icons name="arrowDownThin" />
                                              </i>
                                            </div>
                                            {this.state.showPaymentTypeList ? (
                                              <OnClickOutside
                                                handleClickOutside={() =>
                                                  this.setState({ showPaymentTypeList: false })
                                                }>
                                                <ul
                                                  className={`dropdown-menu show dropdown-menu-manage dropdown-menu-right max-height-200 overflow-y-scrollbar width-50 text-center ${styles['small-dropdown']}`}>
                                                  {amountTypes.map((type, index) => (
                                                    <li
                                                      key={index}
                                                      className="primary-font px-15"
                                                      onClick={(e) => {
                                                        e.stopPropagation()
                                                        this.selectMinimumAmountType(type.value)
                                                        this.setState({ showPaymentTypeList: false })
                                                      }}>
                                                      <span>{type.label}</span>
                                                    </li>
                                                  ))}
                                                </ul>
                                              </OnClickOutside>
                                            ) : null}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        {/* end Collect Payment at Checkout */}

                        {/* Payment Details */}
                        {/* <div className="border rounded mb-10">
                                                    <div className={`d-flex align-items-center px-15 ${styles["card-row-item-height"]}`}>
                                                        <h4 className="mb-0 fz-14">Payment Details</h4>
                                                    </div>
                                                    <div className="d-flex align-items-center border-top py-5 py-sm-0">
                                                        <div className={`w-50 d-flex align-items-center ${styles["card-row-item-height"]}`}>
                                                            <div className="d-flex align-items-center h-100 px-15">
                                                                <span className="line-height-normal">Payment Due Upon Booking</span>
                                                            </div>
                                                        </div>
                                                        <div className={`d-flex align-items-center justify-content-between px-15 w-50 ${styles["card-row-item-height"]}`}>
                                                            <span className="line-height-normal">Immediately</span>
                                                            <div className={"dropdown btn btn-lg pl-15 pr-0 border-0 b-manage-dropdown bg-white"} id="" >
                                                                <div className="dropdown-toggle dropdown-toggle-manage btn-manage" data-toggle="dropdown">
                                                                    <i className={`btn-icon manage-icon-arrow ${styles["icon-dropdown-arrow"]}`}><Icons name="arrowDownThin" /></i>
                                                                </div>
                                                                <ul className="dropdown-menu dropdown-menu-manage dropdown-menu-right max-height-200 overflow-y-scrollbar">
                                                                    <li className="primary-font px-15"><span>Test1</span></li>
                                                                    <li className="primary-font px-15"><span>Test1</span></li>
                                                                    <li className="primary-font px-15"><span>Test1</span></li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-center border-top py-5 py-sm-0">
                                                        <div className={`w-50 d-flex align-items-center ${styles["card-row-item-height"]}`}>
                                                            <div className="d-flex align-items-center h-100 px-15">
                                                                <span className="line-height-normal mr-10">Missed Appoinment Fee</span>
                                                                <div className="cursor-pointer position-relative top-minus-1">
                                                                    <Tooltip position="top" message="Deposit/Partial Payment" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className={`d-flex align-items-center justify-content-between px-15 w-50 ${styles["card-row-item-height"]}`}>
                                                            <Field disabled={values.price ? false : true}
                                                                id="frm_addService_txtMissAppFee"
                                                                type="number"
                                                                className={`form-control form-control-lg px-0 border-0 bg-white ${styles["field-normal-width"]}`}
                                                                placeholder="0"
                                                            />
                                                            <div className={"d-flex align-items-center"}>
                                                                <span>$</span>
                                                                <div className={"dropdown btn btn-lg pr-0 pl-15 border-0 b-manage-dropdown bg-white"} id="" >
                                                                    <div className="dropdown-toggle dropdown-toggle-manage btn-manage" data-toggle="dropdown">
                                                                        <i className={`btn-icon manage-icon-arrow ${styles["icon-dropdown-arrow"]}`}><Icons name="arrowDownThin" /></i>
                                                                    </div>
                                                                    <ul className={`dropdown-menu dropdown-menu-manage dropdown-menu-right max-height-200 overflow-y-scrollbar width-50 text-center ${styles["small-dropdown"]}`}>
                                                                        <li className="primary-font px-15"><span>$</span></li>
                                                                        <li className="primary-font px-15"><span>%</span></li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> */}
                        {/* end Payment Details */}

                        {/* management */}

                        <div className="d-flex align-items-center justify-content-between">
                          <label className="label-text text-uppercase">management</label>
                          <label className={`label-text text-uppercase fz-12 ${styles['private-label-text']}`}>
                            {t('services.private-to-you')}
                          </label>
                        </div>
                        <div className="border rounded mb-15">
                          <div className="d-flex align-items-center py-5 py-sm-0 position-relative">
                            <div className={`w-50 d-flex align-items-center ${styles['card-row-item-height']}`}>
                              <div className="d-flex align-items-center h-100 px-15">
                                <span className="line-height-normal">{t('services.notify-business-owner')}</span>
                              </div>
                            </div>
                            <div
                              className={`d-flex align-items-center justify-content-between px-15 w-50 ${styles['card-row-item-height']}`}>
                              <span className="line-height-normal">{this.getUserNotifyStatus(values)}</span>
                              <div
                                className={
                                  'dropdown btn border-0 b-manage-dropdown position-absolute right-0 left-0 cursor-pointer'
                                }
                                id="">
                                <div
                                  onClick={() => this.setState({ showNotifyList: true })}
                                  className="dropdown-toggle dropdown-toggle-manage btn-manage w-100 bg-transparent text-right"
                                  data-toggle="dropdown">
                                  <i className={`btn-icon ml-10 manage-icon-arrow ${styles['icon-dropdown-arrow']}`}>
                                    <Icons name="arrowDownThin" />
                                  </i>
                                </div>
                                {this.state.showNotifyList ? (
                                  <OnClickOutside handleClickOutside={() => this.setState({ showNotifyList: false })}>
                                    <ul className="dropdown-menu show dropdown-menu-manage dropdown-menu-right max-height-200 overflow-y-scrollbar">
                                      <li className="primary-font px-15">
                                        <div className="form-group form-check d-flex m-0">
                                          <label>
                                            <Field
                                              type="checkbox"
                                              className="h-cb"
                                              checked={values.notify_owner_email}
                                              name="notify_owner_email"
                                              onChange={(event) => {
                                                this.updateField('notify_owner_email', event.target.checked)
                                              }}
                                            />
                                            <span id="frm_addService_chkEmail" className="checkbox-icon mr-10"></span>
                                            <span>Email</span>
                                          </label>
                                        </div>
                                      </li>
                                      <li className="primary-font px-15">
                                        <div className="form-group form-check d-flex m-0">
                                          <label>
                                            <Field
                                              type="checkbox"
                                              className="h-cb"
                                              checked={values.notify_owner_sms}
                                              name="notify_owner_sms"
                                              onChange={(event) => {
                                                this.updateField('notify_owner_sms', event.target.checked)
                                              }}
                                            />
                                            <span id="frm_addService_chkSms" className="checkbox-icon mr-10"></span>
                                            <span>SMS</span>
                                          </label>
                                        </div>
                                      </li>
                                    </ul>
                                  </OnClickOutside>
                                ) : null}
                              </div>
                            </div>
                          </div>
                          <div className="d-flex align-items-center border-top py-5 py-sm-0 position-relative">
                            <div className={`w-50 d-flex align-items-center ${styles['card-row-item-height']}`}>
                              <div className="d-block h-100 px-15">
                                <div className="d-flex align-items-center">
                                  <span className="line-height-normal">{t('services.assigned-user')}</span>
                                  <span className="star text-danger position-relative">*</span>
                                </div>
                                <ErrorMessage
                                  name="user_id"
                                  component="span"
                                  id="lbl_serviceAssignedUser"
                                  className="form-error mt-3 mb-5 ml-0"
                                />
                              </div>
                            </div>
                            <div
                              className={`d-flex align-items-center justify-content-between px-15 w-50 ${styles['card-row-item-height']}`}>
                              <div className={`d-flex align-items-center ${styles['b-profile-image']}`}>
                                <div className={`mr-10 ${styles['service-image']}`}>
                                  <figure className={`rounded-circle ${styles['image-figure']}`}>
                                    <img
                                      className={`rounded-circle ${styles['image-cover']}`}
                                      src={`${
                                        this.state.selectUser && this.state.selectUser.profile_picture
                                          ? this.state.selectUser.profile_picture
                                          : values.user_id
                                          ? this.getUserAvatar(values.user_id, optArray)
                                          : 'https://dufzo4epsnvlh.cloudfront.net/image/user_avatar.svg'
                                      }`}
                                      alt=""
                                    />
                                  </figure>
                                </div>
                                <span className="line-height-normal">
                                  {this.getAssignedUser(values.user_id, optArray)}
                                </span>
                              </div>
                              <div
                                onClick={() => this.setState({ showStaffList: true })}
                                className={
                                  'dropdown btn border-0 b-manage-dropdown position-absolute right-0 left-0 cursor-pointer'
                                }
                                id="">
                                <div
                                  className="dropdown-toggle dropdown-toggle-manage btn-manage w-100 bg-transparent text-right"
                                  data-toggle="dropdown">
                                  <i className={`btn-icon ml-10 manage-icon-arrow ${styles['icon-dropdown-arrow']}`}>
                                    <Icons name="arrowDownThin" />
                                  </i>
                                </div>
                                {this.state.showStaffList ? (
                                  <OnClickOutside handleClickOutside={() => this.setState({ showStaffList: false })}>
                                    <ul className="dropdown-menu show dropdown-menu-manage dropdown-menu-right max-height-200 max-width-200 overflow-y-scrollbar">
                                      {optArray.map((user, index) => (
                                        <li
                                          key={index}
                                          className={`primary-font px-15 ${styles['user-dropdown-list-item']}`}
                                          onClick={(e) => {
                                            e.stopPropagation()
                                            this.onSelectUser(user)
                                            this.setState({ showStaffList: false })
                                          }}>
                                          <div className={`d-flex align-items-center ${styles['b-profile-image']}`}>
                                            <div className={`mr-10 ${styles['service-image']}`}>
                                              <figure
                                                className={`rounded-circle d-flex align-items-center ${styles['image-figure']}`}>
                                                <img
                                                  className={`rounded-circle ${styles['image-cover']}`}
                                                  src={`${
                                                    user.profile_picture
                                                      ? user.profile_picture
                                                      : 'https://dufzo4epsnvlh.cloudfront.net/image/user_avatar.svg'
                                                  }`}
                                                  alt=""
                                                />
                                              </figure>
                                            </div>
                                            <span className={`text-truncate ${styles['list-item-text']}`}>
                                              {user.label}
                                            </span>
                                          </div>
                                        </li>
                                      ))}
                                    </ul>
                                  </OnClickOutside>
                                ) : null}
                              </div>
                            </div>
                          </div>
                          <div className="d-flex align-items-center border-top py-5 py-sm-0">
                            <div className={`w-50 d-flex align-items-center ${styles['card-row-item-height']}`}>
                              <div className="d-flex align-items-center h-100 px-15">
                                <span className="line-height-normal">{t('services.calendar-color')}</span>
                              </div>
                            </div>
                            <div
                              className={`d-flex align-items-center justify-content-between px-15 w-50 ${styles['card-row-item-height']}`}>
                              <div
                                className={`position-relative w-100 ${styles['widget-color-settings']}`}
                                id="frm_addService_sectionCalender">
                                <div
                                  className="d-flex align-items-center"
                                  onClick={() => this.setState({ showColorPicker: true })}>
                                  <div
                                    className={`mr-10 ${styles['widget-color-picker']}`}
                                    style={{ backgroundColor: values.appointment_calendar_color }}></div>
                                  <label className={styles['color-picker-label']}>{t('services.choose-color')}</label>
                                </div>
                                {this.state.showColorPicker ? (
                                  <OnClickOutside handleClickOutside={() => this.setState({ showColorPicker: false })}>
                                    <div className={`position-absolute ${styles['color-picker-popover']}`}>
                                      {/* <div className="position-fixed custom-page-overlay" onClick={() => this.setState({showColorPicker:false})}></div> */}
                                      <div className={`p-10 ${styles['cover']}`}>
                                        <CirclePicker
                                          color={values.appointment_calendar_color}
                                          onChange={(color) => {
                                            this.updateField('appointment_calendar_color', color.hex)
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </OnClickOutside>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* end management */}
                      </div>
                    </div>
                  </div>
                  <footer className="d-block d-sm-flex mt-30">
                    <button
                      type="submit"
                      id="frm_addService_btnAdd"
                      className="btn btn-primary border-0 btn-xl mb-10 mb-sm-0 mr-20 btn-block"
                      disabled={!!this.state.submitting}>
                      {`${this.state.type === 'add' ? t('services.add-service') : t('services.update-service')}`}

                      {this.state.submitting ? (
                        <i className="btn-icon top-minus-2">
                          <img
                            className="spinner"
                            src="https://dufzo4epsnvlh.cloudfront.net/image/default.svg"
                            alt=""
                          />
                        </i>
                      ) : null}
                    </button>
                    <button
                      type="reset"
                      id="frm_addService_btnCancel"
                      className="btn btn-xl btn-outline m-0 cancel-btn custom-btn-width">
                      {'CANCEL'}
                    </button>
                  </footer>
                </Form>
              )
            }}
          />
        ) : (
          <Formik
            validateOnChange={true}
            validateOnBlur={false}
            enableReinitialize={this.state.reenitialiseStatus}
            initialValues={{
              title:
                this.state.selectedItem && Object.keys(this.state.selectedItem) !== 0 && this.state.selectedItem.title
                  ? this.state.selectedItem.title
                  : '',
              price:
                this.state.selectedItem && Object.keys(this.state.selectedItem) !== 0 && this.state.selectedItem.price
                  ? this.state.selectedItem.price
                  : '',
              user_id: this.props.me && this.props.me._id ? this.props.me._id : ''
            }}
            validationSchema={Yup.object().shape({
              title: Yup.string().required(t('bookings.required'))
              // price: Yup.string().required("Required"),
            })}
            onReset={this.handleCancel.bind(this)}
            onSubmit={this.handleSubmit.bind(this)}
            render={({ values, setFieldValue, resetForm }) => {
              values.minimum_payment_amount = values.price ? values.minimum_payment_amount : ''
              return (
                <Form id="frm_addService" className={`common-add-service-modal mt-10 ${styles['add-service-modal']}`}>
                  <button type="reset" id="closeIcon" className="close custom-modal-close-button remove-modal-close">
                    <span aria-hidden="true"></span>
                  </button>
                  {this.state.dataFetching ? (
                    <div
                      className={`position-absolute top-0 right-0 z-index-2 bottom-0 left-0 d-flex align-items-center justify-content-center ${styles['form-loader']}`}>
                      <img src="https://dufzo4epsnvlh.cloudfront.net/image/loader-dot.svg" alt="loader" />
                    </div>
                  ) : null}
                  <div className="row no-gutters">
                    <div className="col-12">
                      <div className="form-group">
                        {/* Customer facing details */}
                        <label className="label-text text-uppercase">{t('services.customer-facing-details')}</label>
                        <div className="border rounded mb-15">
                          <div className="d-flex align-items-center border-bottom">
                            <div className={`${styles['b-card-item-small']}`}>
                              <div className="d-block h-100 pl-15">
                                <div className="d-flex align-items-center">
                                  <span className="line-height-normal">{t('services.service-name')}</span>
                                  <span className="star text-danger position-relative">*</span>
                                </div>
                                <ErrorMessage
                                  name="title"
                                  component="span"
                                  id="lbl_serviceNameError"
                                  className="form-error mt-3 mb-5 ml-0"
                                />
                              </div>
                            </div>
                            <div className={`${styles['b-card-item-large']}`}>
                              <Field
                                id="frm_addService_txtServiceName"
                                type="text"
                                className="form-control form-control-lg border-0 text-truncate"
                                placeholder={t('services.enter-service-name')}
                                name="title"
                                value={values.title}
                                onChange={(e) => {
                                  const { value } = e.target
                                  setFieldValue('title', value)
                                }}
                                onBlur={(e) => {
                                  const { value } = e.target
                                  this.updateField('title', value)
                                }}
                              />
                            </div>
                          </div>
                          <div className="d-flex align-items-center border-bottom">
                            <div className={`${styles['b-card-item-small']}`}>
                              <div className="d-block h-100 px-15">
                                <div className="d-flex align-items-center">
                                  <span className="line-height-normal">{t('services.price')}</span>
                                  {/* <span className="star text-danger position-relative">*</span> */}
                                </div>
                                {/* <ErrorMessage name="price" id="lbl_servicePriceError" component="span" className="form-error mt-3 mb-5 ml-0" /> */}
                              </div>
                            </div>
                            <div className={`${styles['b-card-item-large']}`}>
                              <Field
                                id="frm_addService_txtPayemntAmount"
                                type="number"
                                className={'form-control form-control-lg border-0'}
                                placeholder={t('services.service-charge')}
                                name="price"
                                onChange={(e) => {
                                  const { value } = e.target
                                  const regex = /^(0*[0-9][0-9]*(\.[0-9]{0,2})?|0*\.[0-9]{0,2})$/
                                  if (regex.test(value.toString()) || value.length === 0) {
                                    this.updateField('price', value)
                                  }
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <footer className="d-block d-sm-flex mt-10">
                    <button
                      type="submit"
                      id="frm_addService_btnAdd"
                      className="btn btn-primary border-0 btn-xl mb-10 mb-sm-0 mr-20 btn-block"
                      disabled={!!this.state.submitting}>
                      {`${this.state.type === 'add' ? t('services.add-service') : t('services.update-service')}`}

                      {this.state.submitting ? (
                        <i className="btn-icon top-minus-2">
                          <img
                            className="spinner"
                            src="https://dufzo4epsnvlh.cloudfront.net/image/default.svg"
                            alt=""
                          />
                        </i>
                      ) : null}
                    </button>
                    <button
                      type="reset"
                      id="frm_addService_btnCancel"
                      className="btn btn-xl m-0 cancel-btn custom-btn-width">
                      {'CANCEL'}
                    </button>
                  </footer>
                </Form>
              )
            }}
          />
        )}
        {this.state.showBookingHoursModal ? (
          <BusinessHoursModal
            open={true}
            title={t('services.custom-booking-hours-0')}
            close={this.closeCustomHoursModal.bind(this)}
            business_hours={
              this.state.selectedItem &&
              Object.keys(this.state.selectedItem) !== 0 &&
              this.state.selectedItem.business_hours &&
              Object.keys(this.state.selectedItem.business_hours).length !== 0
                ? this.sortArrayFunction(this.state.selectedItem.business_hours)
                : JSON.parse(JSON.stringify(defaultHours))
            }
            submitHours={this.getBusinessHours.bind(this)}
          />
        ) : null}
      </Popup>
    )
  }
}
export default AddServicePopUp
